<template>
  <app-modal
    v-if="show"
    :maxWidth="maxWidth"
    :maxHeight="maxHeight"
    :isClickMaskClose="false"
    :fullHeight="true"
    :useBorder="true"
    @close="hideModal"
  >
    <div class="object-info">
      <h3>{{ $t("info_title", { name }) }}</h3>

      <el-collapse :value="activeNums">
        <el-collapse-item
          v-for="(item, index) in info"
          :key="index"
          :title="title(item)"
          :name="index"
        >
          <object-info-item class="object-info__content" :item="item" />
        </el-collapse-item>
      </el-collapse>

      <el-divider class="object-info__divider" content-position="left">
        {{ $t("info_footer") }}
      </el-divider>

      <el-button
        class="object-info_close"
        icon="el-icon-close"
        type="primary"
        circle
        :title="$t('info_close')"
        @click="hideModal"
      ></el-button>
    </div>
  </app-modal>
</template>

<script>
import ObjectInfoItem from "./ObjectInfoItem.vue";

export default {
  name: "ObjectInfo",
  components: {
    ObjectInfoItem,
    AppModal: () =>
      import(
        /* webpackChunkName: "appModal" */ "@/components/library.blocks/AppModal.vue"
      )
  },
  props: {
    maxWidth: {
      type: String,
      default: "100%"
    },
    maxHeight: {
      type: String,
      default: "100%"
    },
    show: {
      type: Boolean,
      default: false
    },
    info: Array,
    name: String
  },
  data() {
    return {
      activeNums: []
    };
  },
  computed: {},
  methods: {
    hideModal() {
      this.$emit("close");
    },
    setActiveNums() {
      this.activeNums = [];
      if (this.info) {
        for (let i = 0; i < this.info.length; i++) {
          this.activeNums.push(i);
        }
      }
    },
    title(obj) {
      return obj && obj.name ? obj.name : `[${obj.code}]`;
    }
  },
  mounted() {
    this.setActiveNums();
  },
  watch: {
    info: function () {
      this.setActiveNums();
    }
  }
};
</script>

<style lang="scss">
@import "@/css/variables.scss";

.object-info {
  margin: 0 10px;
  position: relative;

  .el-collapse-item__header {
    font-size: 18px !important;
    font-weight: 600 !important;
    color: $company_color !important;
    padding-left: 15px !important;
  }

  .el-collapse-item__content {
    padding-bottom: 0 !important;
  }

  .object-info__content {
    text-align: justify;
    padding: 0 15px !important;
  }

  .object-info_close {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .object-info__divider .el-divider__text {
    background-color: $free_zone_color;
  }
}
</style>
